import React from 'react'

export default function Footer() {
  return (
    <div className="mb-8 text-center">
      <a className="text-gray-300 hover:underline" href="/admin/" color="textSecondary">
        Admin
      </a>
    </div>
  )
}
